const linkGen = str => {
  return str.split(" ").join("-");
};

export default linkGen;
